import { Center, Flex } from '@chakra-ui/react';
import { ReactComponent as VenngageLogoIcon } from 'assets/icons/venngage_logo.svg';
import { useAppSelector } from 'modules/Editor/store';
import {
  selectInfographHeightPx,
  selectInfographWidthPx,
  selectPageBackgroundString,
} from 'modules/Editor/store/infographSelector';
import { selectActivePage } from 'modules/Editor/store/pageSelector';
import { Page } from 'modules/common/components/Page';
import { CSSProperties, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ReadOnlyRenderType } from 'widgets/Widget.types';
import { WidgetRenderer } from 'widgets/WidgetRenderer';

import { PREVIEW_PANEL_MAX_HEIGHT } from './PreviewPanel.config';

const logoStyle: CSSProperties = {
  width: '14px',
  height: '14px',
  color: 'white',
};

const PreviewThumbnail = () => {
  const widthPx = useAppSelector(selectInfographWidthPx);
  const heightPx = useAppSelector(selectInfographHeightPx);
  const activePageId = useAppSelector(selectActivePage);
  const pageBackground = useAppSelector(selectPageBackgroundString(activePageId));

  const pageScale = 0.23;

  const infographRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation('common_navbar');
  const infographContainerAriaLabel = t('infographContainerAriaLabel');

  return (
    <Flex
      w={'100%'}
      pt={0}
      top={0}
      position={'absolute'}
      bgColor={'var(--vg-colors-privateLinkView-wrapperBg)'}
      justifyContent={'center'}
      alignItems={heightPx >= PREVIEW_PANEL_MAX_HEIGHT ? 'start' : 'center'}
      pointerEvents={'none'}
      h={'100%'}
    >
      <Center flexDir={'column'} ref={infographRef} aria-label={infographContainerAriaLabel} mt={2}>
        <Page
          testId={activePageId}
          className='page-container'
          bg={pageBackground}
          width={widthPx}
          height={heightPx}
          zoom={pageScale}
          borderRadius='none'
          boxShadow='none'
          overflow='hidden'
        >
          {/* pass a new renderType prop */}
          <WidgetRenderer pageId={activePageId} isReadOnly renderType={ReadOnlyRenderType.ThumbnailReadOnly} />
        </Page>
      </Center>
      {/* Navbar Preview */}
      <PreviewThumbnailNavbar />
    </Flex>
  );
};

export default PreviewThumbnail;

const PreviewThumbnailNavbar = () => {
  return (
    <Flex
      position={'absolute'}
      bottom={0}
      w={'100%'}
      h={'25px'}
      px={5}
      py={1}
      bgColor={'var(--vg-colors-privateLinkView-navbarBg)'}
      justifyContent={'space-between'}
      alignItems={'center'}
    >
      <VenngageLogoIcon aria-hidden='true' style={logoStyle} />
    </Flex>
  );
};
